export const formatLessonNumber = (lessonNumber: number): string =>
  String(lessonNumber).padStart(2, "0");
